import styled from 'styled-components'

export default styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: inherit;
  flex: 1;
`
